import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '~router/routePaths';

import { HEADER_HEIGHT } from '../Dispatch/components/drivers/constants';

type PageNotFoundErrorPageProps = {
  isLoggedIn?: boolean;
};

export const PageNotFoundErrorPage = ({ isLoggedIn }: PageNotFoundErrorPageProps) => {
  const navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          height: `calc(50vh - ${HEADER_HEIGHT}px)`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Grid
          container
          sx={{
            width: '100%',
            maxWidth: '500px',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Typography variant="h3">🚧</Typography>
          <Typography variant="h4">{t('error_pages.page_not_found.title')}</Typography>
          <Typography variant="subtitle1">
            {t('error_pages.page_not_found.description')}
          </Typography>
          {!isLoggedIn && (
            <Box
              sx={{
                display: 'flex',
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate(`/${ROUTES.signIn}`)}
              >
                {t('actions.signIn')}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => (window.location.href = 'https://tread.ai')}
              >
                {t('error_pages.page_not_found.learn_about_tread')}
              </Button>
            </Box>
          )}
        </Grid>
      </Box>
    </>
  );
};
